import { render } from "./MdcSelect.vue?vue&type=template&id=3565aeb4"
import script from "./MdcSelect.vue?vue&type=script&lang=js"
export * from "./MdcSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__